import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-panel-stripe-applepay',
  templateUrl: './payment-panel-stripe-applepay.component.html',
})
export class PaymentPanelStripeApplepayComponent {}
